import {
  Tabs,
} from "antd";
import React, {
  forwardRef,
  useState,
} from "react";
// import "./CompletedTable.scss";
import Mortgage from "@/views/AccountPayable/Mortgage";
import GroupByProp from "@/views/AccountPayable/Mortgage/GroupByProp";

const MainTable = forwardRef((props, ref) => {
  const [tabsKey, setTabsKey] = useState(1);

  return (
    <div>
      <Tabs 
        defaultActiveKey={tabsKey}
        forceRender
        items={[
          {key: 1, label: "Mortgage", children: <Mortgage />},
          {key: 2, label: "Group By Prop", children: <GroupByProp />},
        ]}
        onChange={key => setTabsKey(key)}
      />
    </div>
  );
});
export default MainTable;